<template>
    <div class="flex items-start gap-x-6 p-8">


        <div class="w-1/3">

            <div v-html="report.html" class="prose"></div>


            <div class="mt-4 prose" v-if="report.photos && report.photos.length >0">
                <h3>Attachments</h3>

                <div class="grid grid-cols-3 gap-4">
                    <div v-for="photo in report.photos">
                        <a :href="photo" target="_blank">
                            <img :src="photo" />
                        </a>
                    </div>
                </div>

            </div>



        </div>

        <div class="flex-1">
            <h2 class="font-bold text-2xl mb-6">Résolution:</h2>

            <template v-if="report.status === 1">
                Crédit de ${{ report.resolution.credit_amount.toFixed(2) }} approuvé par [{{ report.resolution.by_livro && !admin ? "Livro" :  report.resolution.resolved_by }}]


                <div v-if="report.resolution.comments!==''">
                    Commentaires:
                    <div>
                        {{ report.resolution.comments }}
                    </div>
                </div>

            </template>

            <template v-else-if="report.status === 2">
                Crédit rejeté par [{{ report.resolution.by_livro && !admin ? "Livro" : report.resolution.resolved_by }}]

                <div v-if="report.resolution.comments!==''">
                    Commentaires:
                    <div>
                        {{ report.resolution.comments }}
                    </div>
                </div>

            </template>
            <template v-else>
                <div class="divide-gray-400 divide-y">

                    <div class="py-2" v-for="credit in credits">

                        <div>
                            <template v-if="credit.taxable">Crédit taxable</template>
                            <template v-else>Crédit non-taxable</template>
                        </div>

                        <input
                            class="px-4 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            v-model="credit.amount" />

                        <span v-if="credit.taxable">+tax = ${{ (credit.amount * 1.14975).toFixed(2) }}</span>

                    </div>


                </div>
              
              <div v-if="admin && !non_affiliated" class="mt-6">
                <div class="mb-4"><Checkbox v-model="affects">Affects Merchant</Checkbox></div>
                <div><Checkbox v-model="notify">Notify Merchant</Checkbox></div>
                
              </div>


                <div class="flex items-start gap-x-4 my-6 w-full">

                    <div class="">
                        <label for="comment" class="block text-sm font-medium leading-6 text-gray-900">Commentaires</label>
                        <div class="mt-2">
                            <textarea rows="4" v-model="comments" name="comment" id="comment" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"></textarea>
                        </div>
                    </div>




                </div>



                <div class="flex items-center gap-x-6">

                    <template v-if="valid">

                        <ConfirmableButton @confirm="approve" apply="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Approuver ${{ total.toFixed(2) }}</ConfirmableButton>

                        <ConfirmableButton @confirm="reject" apply="rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">Rejeter</ConfirmableButton>

                    </template>

                    <template v-else>
                        Invalid credit amount. (max: ${{ max.toFixed(2) }} before tax)
                    </template>

                </div>

            </template>



        </div>


    </div>
</template>

<script>
import ConfirmableButton from "../../Shared/ConfirmableButton.vue";
import Checkbox from "../../Shared/Checkbox.vue";

export default {
    name: "ProblemResolutionPane",

    props: ['report', 'max', 'admin', 'non_affiliated'],
    components: {Checkbox, ConfirmableButton},

    data() {
        let credits = this.report.resolution.proposed_credit;
        if (!credits || credits.length === 0) {
            credits = [{'amount': 0, 'taxable' : false}];
        }

        return {
            resolution: '',
            credits: credits,
            affects: this.non_affiliated ? false : true,
            notify: this.non_affiliated ? false : true,
            comments: '',
        }
    },

    computed: {
        total() {
            return this.credits.map(c => c.taxable ? c.amount * 1.14975 : c.amount * 1).reduce((a, b) => a+b, 0);
        },
        total_pre_tax() {
            return this.credits.reduce((s, c) => s + (c.amount * 1), 0);
        },

        valid() {
            return this.total_pre_tax <= this.max;
        }
    },

    methods: {

        reject() {
            this.$emit("reject", {
                credits: this.credits,
                comments: this.comments,
              affects: this.affects, notify: this.notify,
            })
        },

        approve() {
            this.$emit("approve", {
                credits: this.credits,
                comments: this.comments,
              affects: this.affects, notify: this.notify,
            })
        },


    }
    
}
</script>

<style scoped>

</style>
